import { MdbaseConnectError, connectError } from "./errors.js";
export function declarationIdFromFamilyIdentity(familyIdentity) {
    const prefix = "bundle:";
    if (!familyIdentity.startsWith(prefix) || familyIdentity.length === prefix.length) {
        throw new Error("The registered application has no valid declaration identity.");
    }
    return familyIdentity.slice(prefix.length);
}
export function authorizationAbort(signal, message, cause) {
    if (signal.reason instanceof MdbaseConnectError)
        return signal.reason;
    return connectError("authorization_cancelled", message, { cause });
}
